
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearNightColour as ObiClearNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-night-colour.js';
 
 
 

 
 export const ObiClearNightColour = createComponent({
   react: React,
   tagName: 'obi-clear-night-colour',
   elementClass: ObiClearNightColourElement,
   events: {
     
   }
  });
 
 